export class DataHelper {
    constructor() {}
    static sortDate(a: Date | string, b: Date | string, direction: 'asc' | 'desc' | ''): number {
        return direction === 'desc'
            ? new Date(a).getTime() - new Date(b).getTime()
            : new Date(b).getTime() - new Date(a).getTime();
    }
    static sortNumber(a: number, b: number, direction: 'asc' | 'desc' | ''): number {
        return direction === 'desc' ? a - b : b - a;
    }
    static SortString(a: string, b: string, direction: 'asc' | 'desc' | ''): number {
        return direction === 'desc' ? a.localeCompare(b) : b.localeCompare(a);
    }
}
